import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';

/**
 * API
 */
import settingsAPI, { SettingsResponseModel } from '@/api/settings';

/**
 * Module VueX de gestion des permissions des agents.
 */
@Module({
	namespaced: true
})
export default class ClientSettings extends VuexModule {
	/** State */
	clientSettings: SettingsResponseModel | null = null;

	/** Mutations */
	@Mutation
	FETCH_CLIENT_SETTINGS_SUCCESS(settings: SettingsResponseModel) {
		this.clientSettings = settings;
	}

	/** Actions */
	@Action({ commit: 'FETCH_CLIENT_SETTINGS_SUCCESS' })
	async fetchClientSettings() {
		return await settingsAPI.getClientSettings();
	}

	/** Getters */
	get settings(): SettingsResponseModel {
		return this.clientSettings!;
	}
}